import { memo } from "react";

import Stack from "@mui/material/Stack";

import IgnoreAction from "../../../Ignore/IgnoreAction";

import { Finding, FindingState, IgnorableStates } from "stores/FindingStore";

import Acknowledge from "./Acknowledge";
import EditSeverity from "./EditSeverity";

// -----------------------------------------------------------------------------

const OrganizationFindingDetailsActions = memo(
  function OrganizationFindingDetailsActions({
    finding,
  }: OrganizationFindingDetailsActionsProps): JSX.Element {
    const canAcknowledge = finding.state === FindingState.New;
    const canIgnore = IgnorableStates.includes(finding.state);

    //
    return (
      <Stack direction="row" spacing={1} flexWrap="wrap" ml={1}>
        {canAcknowledge && <Acknowledge finding={finding} />}
        {canIgnore && (
          <IgnoreAction
            ignored={finding.state === FindingState.Suppressed}
            finding={finding}
          />
        )}
        <EditSeverity finding={finding} />
      </Stack>
    );
  }
);

export default OrganizationFindingDetailsActions;

// -----------------------------------------------------------------------------

interface OrganizationFindingDetailsActionsProps {
  finding: Finding;
}
